import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "noaccess" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Sorry!!! Currently you don't have access to this page.", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", null, "Please contact administerator to get access.", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", null, "Thank You.", -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5))
}